import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';

export default connect((state) => state)(
  class extends Component {
    render() {
      const {
        compactStyle,
        icon,
        file,
        fileError,
        fontSize,
        infoText,
        messages,
        onRemove,
        placeholder,
        showRemove,
        size,
        theme,
        uppyElementRef
      } = this.props;

      return (
        <div
          className="uppy"
          ref={uppyElementRef}
          style={{
            fontSize: {
              small: '1.3rem',
              medium: '1.4rem',
              large: '1.5rem',
              huge: '1.8rem'
            }[fontSize]
          }}
        >
          {file ? (
            <div className="content">
              {`${file.name}${size ? ` (${size})` : ''}`}
              {fileError ? <div>{fileError}</div> : null}
              {showRemove ? (
                <button
                  aria-label={messages.uploaderRemoveFile}
                  className="remove"
                  onClick={onRemove}
                  type="button"
                >
                  <Icon icon="times" />
                </button>
              ) : null}
            </div>
          ) : (
            <div className="content">
              <div className="content-icon">
                <Icon icon={icon} />
              </div>
              {fileError ? (
                fileError
              ) : (
                <div>
                  {placeholder}
                  {infoText && (
                    <div className="sub-content">
                      <div className="sub-content-inner">{infoText}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          <style jsx>{`
            .uppy {
              display: inline-block;
              position: relative;
              width: 100%;
            }
            .content {
              background-color: white;
              border: 2px dashed #ccc;
              border-radius: ${theme.cardBorderRadius};
              color: ${fileError ? theme.dangerColor : theme.textColorLight};
              display: inline-block;
              font-weight: 600;
              padding: ${compactStyle ? '10px' : '30px 10px'};
              text-align: center;
              width: 100%;
            }
            .content-icon {
              display: ${compactStyle ? 'inline-block' : 'block'};
              font-size: ${compactStyle ? 'inherit' : '2.6rem'};
              margin-bottom: ${compactStyle ? '0' : '5px'};
              margin-right: ${compactStyle ? '7px' : '0'};
            }
            .remove {
              background-color: transparent;
              border: 0;
              color: ${theme.textColorLighter};
              cursor: pointer;
              display: 'inline-block';
              margin: 0 0 0 10px;
              padding: 2px 7px;
              position: relative;
              top: 1px;
              transition: color 0.3s;
            }
            .remove:hover {
              color: ${theme.textColor};
            }
            .sub-content {
              font-weight: 400;
              margin-top: 5px;
            }
            .sub-content-inner {
              display: inline-block;
              max-width: 600px;
            }
            .uppy :global(.uppy-DragDrop-container) {
              background-color: #fff;
              border: none;
              border-radius: 3px;
              cursor: pointer;
              margin: 0;
              opacity: 0.3;
              padding: 0;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              transition: border 0.3s;
              z-index: ${file ? -1 : 1};
            }
            .uppy :global(.uppy-DragDrop-container:hover) {
              color: #000;
              border-color: #000;
            }
            .uppy :global(.uppy-DragDrop--isDraggingOver) {
              background-color: #ddd;
              border-color: #000;
            }
            .uppy :global(.uppy-DragDrop-input) {
              opacity: 0;
              overflow: hidden;
              position: absolute;
              height: 0.1px;
              width: 0.1px;
              z-index: -1;
            }
            .uppy :global(.uppy-DragDrop-inner) {
              display: none;
            }
          `}</style>
        </div>
      );
    }
  }
);
